import womencellactivityone from "../../../assets/CampuLifeImages/womencellactivity1.jpg"
import womencellactivitytwo from "../../../assets/CampuLifeImages/womencellactivity2.jpg"
import womencellactivitythree from "../../../assets/CampuLifeImages/womencellactivity3.jpg"
import ExtenStudClubGrievPage from '../../CampusSharedComponent/CampusDynamicPages/CampusExtenStudClubGrievDynamicPage/ExtenStudClubGrievPage';
import womencellbanner from "../../../assets/CampuLifeImages/womencellbanner.jpg"
const WomenCell = () => {
   const womenCellContent = {
    name:"womencell",
    pagename:"Women’s Cell",
    title:"Women Cell Activities",
    contentImg:womencellbanner,
    paratitle:"Objectives :",
    hover:true,
    viewmore:"true",
    viewless:"true",
   paracontent2:"The Women's Cell at our college is dedicated to fostering an inclusive and empowering environment, focusing on the development of women. Its primary goal is to promote gender equality, advocate for women’s rights, and provide a safe space for women to voice their concerns. It raises awareness like gender-based discrimination, mental health, and societal challenges. It organizes counseling sessions to help women navigate personal and academic challenges with confidence. The mission is to champion the holistic development and well-being of women within the institution.",
   paraone:"It offers a platform for women to discuss aspirations, seek mentorship, and enhance their skills through developmental activities. It focuses on promoting the welfare, well-being, and empowerment of female students and staff.By celebrating achievements and providing support, the Women's Cell  encourages female students  and staff members to take on leadership roles both on and off-campus. Through its initiatives, the Women's Cell strives to create a campus culture where women are empowered to excel and have equal opportunities for growth. Ultimately, it aims to make the college a place where respect, equality, and inclusivity thrive for all.",
   threehover:true
  }
  
  const hoverContent = [
    {img:womencellactivityone , para1:"International Womens Day Celebration",para2:"2025"},
    {img:womencellactivitytwo , para1:"International Womens Day Celebration",para2:"2025"},
    {img:womencellactivitythree , para1:"International Womens Day Celebration",para2:"2025"},
  ]


  const tableData = [
            {title:"Women cell Members"},
            {headings:[{heading1:"S.No.",heading2:"Name",heading4:"Position"}]},
            {data:[{ id: 1, name: 'Dr. S. Padma Devi' ,pos:"Convenor"},
            { id: 2, name: 'Mrs. P. N. Sukitha', pos:"Member"},
            { id: 3, name: 'Mrs. S. G. Sugitha', pos:"Member"},
            { id: 4, name: 'Mrs. V. Ajila Jothi', pos:"Member"},
            { id: 5, name: 'Mrs. S. K. Sree Devi', pos:"Member"}
          ]},
          {padding:true}
          ];

          
  return (
    <>

      <ExtenStudClubGrievPage data={womenCellContent} hoverContent={hoverContent} tableData={tableData} />

    </>
  )
}

export default WomenCell